import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';

interface VendorDetailsRequestIntroFooterProps {
  businessName: string | null;
  askVendorHelpCenterUrl: string;
  onReceivePaymentClick: () => void;
  isLoading: boolean;
}

export const VendorDetailsRequestIntroFooter = ({
  businessName,
  askVendorHelpCenterUrl,
  onReceivePaymentClick,
  isLoading,
}: VendorDetailsRequestIntroFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className=' flex flex-col  items-center pb-[32px] w-full max-w-[367px] '>
      <div className=' w-full'>
        <LiliButton
          id='receive-payment-button'
          title='Receive Payment'
          onClick={onReceivePaymentClick}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </div>
      <div className='flex gap-0 mt-[32px]'>
        <p className='font-metricR text-[14px] text-bw08  text-center'>
          {`${t('ASK_VENDOR.INTRO.DISCLAIMER_1')} `}
          <a
            className='font-metricRMedium  text-action03 hover:cursor-pointer'
            href={askVendorHelpCenterUrl}
            target='_blank'
            rel='noreferrer'
          >
            {t('ASK_VENDOR.INTRO.DISCLAIMER_2')}
          </a>
        </p>
      </div>
      <p className='font-metricR text-[14px] text-bw08 mt-[4px] '>
        {businessName && t('ASK_VENDOR.INTRO.DISCLAIMER_3', { businessName })}
      </p>
    </div>
  );
};
